module.exports = __webpack_public_path__ + "img/jiaoyu2.2c70a700.png";